import React from 'react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp" initial={{
    opacity: 0,
    scale: 0.5
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 15
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-50 group flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/30 hover:shadow-[#25D366]/50 transition-shadow" data-id="element-201">
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" style={{
      animationDuration: '2s'
    }} data-id="element-202"></span>

      {/* WhatsApp icon */}
      <svg viewBox="0 0 32 32" className="relative w-7 h-7 md:w-8 md:h-8 text-white fill-current" aria-hidden="true" data-id="element-203">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.493-1.318.187-.43.215-.957.215-1.418 0-.142-.043-.214-.157-.214-.27 0-1.49-.602-1.792-.602zM16 1.146c-8.213 0-14.853 6.64-14.853 14.853 0 2.706.726 5.343 2.108 7.65L1 30l6.55-2.135C9.876 28.987 12.42 29.7 16 29.7c8.213 0 14.853-6.64 14.853-14.854C30.853 7.787 24.213 1.146 16 1.146zM16 27.354c-2.45 0-4.85-.674-6.94-1.937l-.49-.295-5.115 1.677L5.122 21.6l-.295-.49a12.6 12.6 0 0 1-1.937-6.94c0-7.013 5.7-12.714 12.714-12.714S28.318 7.158 28.318 14.17 22.617 27.354 16 27.354z" data-id="element-204" />
      </svg>

      {/* Hover label */}
      <span className="absolute right-full mr-3 px-3 py-1.5 rounded-lg bg-teal-950 text-cream text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg" data-id="element-205">
        Escríbeme por WhatsApp
      </span>
    </motion.a>;
}